import { computed, type ComputedRef } from 'vue'
import { useSamudkoyStore } from '../../stores/samudkoy'

interface UseButtonTranslateClose {
  show: ComputedRef<boolean>
  doPopupTranslateClose: Function
}

//------------------------------------------------
export function useButtonTranslateClose(): UseButtonTranslateClose {
  const samudkoyStore = useSamudkoyStore()

  const show = computed(() => samudkoyStore.translate)

  function doPopupTranslateClose() {
    samudkoyStore.translateOff()
  }

  return {
    show,
    doPopupTranslateClose,
  }
}

//------------------------------------------------
export function useButtonTranslateCloseMock(): UseButtonTranslateClose {
  const show = computed(() => true)

  function doPopupTranslateClose() {
    console.debug('doPopupTranslateClose()')
  }

  return {
    show,
    doPopupTranslateClose,
  }
}
